<template>
    <AuthLayout>
        <div class="md:py-12 md:px-8 w-full max-w-lg p-6 mx-auto bg-white border rounded-lg shadow-sm">
            <h2 class="mt-0 mb-8 text-2xl font-bold leading-9 tracking-tight text-center text-gray-700">
                {{ $t('auth.sign_in_to_your_account') }}
            </h2>
            <form class="w-full" @submit.prevent="onSubmit" @keydown="forgetErrorsFor($event.target.name)">
                <div :class="[form.errors.has('email') || form.errors.has('email_or_password') ? 'has-error' : '', 'mb-3']">
                    <label class="mb-1" for="email">{{ $t('auth.email') }}</label>
                    <input class="form-control" id="email" name="email" type="email" required v-model="form.email" />
                    <p class="help-block" v-if="form.errors.has('email')" v-text="form.errors.get('email')"></p>
                    <p class="help-block" v-else-if="form.errors.has('email_or_password')" v-text="form.errors.get('email_or_password')"></p>
                </div>
                <div :class="[form.errors.has('password') ? 'has-error' : '', 'mb-3']">
                    <label class="mb-1" for="password">{{ $t('auth.password') }}</label>
                    <input class="form-control" id="password" name="password" type="password" required v-model="form.password" />
                    <p class="help-block" v-if="form.errors.has('password')" v-text="form.errors.get('password')"></p>
                </div>
                <div class="mb-3">
                    <div class="flex items-center justify-between">
                        <label class="custom-control custom-control-blue-500 custom-checkbox">
                            <input class="custom-control-input" id="remember" name="remember" type="checkbox" v-model="form.remember">
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-label">{{ $t('auth.remember') }}</span>
                        </label>
                        <a href="/password/reset" class="text-blue-500">{{ $t('auth.forgot_password') }}</a>
                    </div>
                </div>
                <div class="pt-2">
                    <button class="btn btn-block btn-primary-blue" :disabled="form.errors.any()" type="submit">
                        {{ $t('auth.login') }}
                    </button>
                </div>
            </form>
        </div>
        <p class="max-w-lg mt-10 text-sm text-center text-gray-600">
            {{ $t('auth.no_account_cta') }}
            {{ ' ' }}
            <a href="/sign-up" class="font-medium text-blue-500">
                {{ $t('auth.sign_up') }}
            </a>
        </p>
    </AuthLayout>
</template>

<script>
import AuthLayout from '../layouts/AuthLayout.vue';

export default {
    components: {
        AuthLayout,
    },

    data() {
        return {
            form: new Form({
                email: '',
                password: '',
                remember: null,
            }),
            tokenForm: new Form({
                organization_application_user_id: '',
                session_data: null,
            }),
            applicationInstance: null,
            applicationForm: new Form({
                user_id: '',
                token: '',
            }),
        };
    },

    methods: {
        onSubmit() {
            Globals.post('/login', this.form)
                .then(user => {
                    const budgetsApplication = user.organization_applications
                        .filter(oa => oa.status === 'active')
                        .find(oa => oa?.application?.slug === 'budgets');
                    if (budgetsApplication) {
                        // Prepare login attempt to the only accessible application
                        window.axios.defaults.headers.common['Authorization'] = `Bearer ${user.api_token}`;
                        this.tokenForm.organization_application_user_id = budgetsApplication.pivot.id;
                        this.applicationInstance = axios.create({ baseURL: budgetsApplication.application.url, withCredentials: true });
                    } else {
                        // Redirect to main dashboard
                        window.location.href = '/dashboard';
                    }
                })
                .then(() => {
                    if (this.applicationInstance) {
                        Globals.post('/api/v1/authentication-token', this.tokenForm)
                            .then(response => {
                                this.applicationForm.user_id = response.user_access.user_id;
                                this.applicationForm.token = response.token;
                            })
                            .then(() => this.applicationInstance.post('/login', this.applicationForm))
                            .then(() => window.location.href = this.applicationInstance.defaults.baseURL)
                            .catch(error => {
                                const redirectPath = (message) => ({
                                    'Your email address is not verified.': '/email/verify',
                                    'You are not a member in an organization yet.': '/awaiting-acceptance',
                                    'You haven\'t seen the welcome message yet.': '/welcome',
                                })[message];
                                if (redirectPath(error.message)) {
                                    window.location.href = redirectPath(error.message);
                                }

                                window.location.href = '/dashboard';
                            });
                    }
                })
                .catch(error => {
                    const redirectPath = (message) => ({
                        'Your email address is not verified.': '/email/verify',
                        'You are not a member in an organization yet.': '/awaiting-acceptance',
                        'You haven\'t seen the welcome message yet.': '/welcome',
                    })[message];
                    if (redirectPath(error.message)) {
                        window.location.href = redirectPath(error.message);
                    }

                    this.form.password = '';
                })
                .finally(() => {
                    this.resetForms();
                });
        },

        forgetErrorsFor(targetName) {
            const emailOrPassword = ['email', 'password'];
            if (emailOrPassword.includes(targetName) && this.form.errors.has('email_or_password')) {
                this.form.errors.forget('email_or_password');
            }
            this.form.errors.forget(targetName);
        },

        resetForms() {
            this.tokenForm = new Form({
                organization_application_user_id: '',
                session_data: null,
            });
            this.applicationForm = new Form({
                user_id: '',
                token: '',
            });
        },
    },
};
</script>
